import React, { useState } from 'react';
import { FaFile } from 'react-icons/fa6';
import toast from 'react-hot-toast';
import { FaCheckCircle } from 'react-icons/fa';

import Loader2 from './../custom/Loader2';

const DataSourceSelectionModal = ({
  closeModal,
  files,
  currentDataSources,
  setCurrentDataSources,
}) => {
  // Pre-select the currently selected files based on the full file objects
  const [selectedDataSources, setSelectedDataSources] = useState([
    ...currentDataSources,
  ]);
  const [isloading, setIsloading] = useState(false);
  const [error, setError] = useState(null);

  const handleSelect = (file) => {
    setSelectedDataSources(
      (prevSelected) =>
        prevSelected.find((selected) => selected.file_id === file.file_id)
          ? prevSelected.filter((selected) => selected.file_id !== file.file_id) // Remove if already selected
          : [...prevSelected, file], // Add if not selected
    );
  };

  const handleConfirm = async () => {
    try {
      setCurrentDataSources(selectedDataSources);
      toast.success('Selected data sources updated');
      closeModal(); // Close the modal
      return;
    } catch (err) {
      setError('Failed to update data sources');
      setIsloading(false);
      toast.error(err.message);
    }
  };

  return (
    <div className="flex w-full">
      <div className="relative w-full rounded-lg text-white shadow-lg">
        <div className="space-y-3">
          <ul className="space-y-2">
            {files.map((file) => {
              // eslint-disable-next-line
              if (file.status != 'success' && !file.accessible) {
                return null;
              }
              const isSelected = selectedDataSources.some(
                (selected) => selected.file_id === file.file_id,
              );
              return (
                // eslint-disable-next-line
                <li
                  key={file.file_id}
                  onClick={() => handleSelect(file)}
                  className={`flex w-full cursor-pointer items-center justify-between rounded-md p-3 ${
                    isSelected
                      ? 'bg-white text-black'
                      : 'bg-zinc-800 text-white'
                  }`}
                >
                  <div className="flex max-w-[70%] items-center gap-2">
                    <span>
                      <FaFile className="text-lg text-[#5566FF]" />
                    </span>
                    <span
                      className={`truncate text-sm ${
                        isSelected ? 'text-black' : 'text-white'
                      }`}
                      title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                    >
                      {file.original_filename}
                    </span>
                  </div>

                  {isSelected ? (
                    <FaCheckCircle className="h-full w-3 text-green-500" />
                  ) : (
                    <div className="h-3 w-3 rounded-full border hover:border-cyan-500"></div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="flex justify-end">
          <button
            onClick={handleConfirm}
            disabled={isloading}
            className="mt-4 flex items-center gap-1 rounded-lg bg-zinc-200 px-3 py-1 text-zinc-800"
          >
            {/* Confirm */}
            {isloading && <Loader2 />}
            {isloading ? 'Confirming' : 'Confirm'}
          </button>
        </div>
        {error && <div className="mb-4 text-red-500">{error}</div>}
      </div>
    </div>
  );
};

export default DataSourceSelectionModal;
